<mat-toolbar [ngClass]="{'dark-toolbar': darkModeService.darkMode, 'mapfre-toolbar': !darkModeService.darkMode}" class="app-toolbar">
  <div class="home-box" (click)="goHome();">
    <img src="assets/images/mapfre-logo.svg" alt="Mapfre Arquitecture Logo" class="logo">
  </div>
  <div class="mar-box" >
    <div class="mar-box-item" (click)="goHome();">
      <mat-icon>home</mat-icon>
      <span>{{ 'NAVBAR.TITLE' | translate }}</span>
    </div>
  </div>
  <mat-slide-toggle (click)="setDarkMode(false);" [(ngModel)]="darkModeService.darkMode" *ngIf="darkModeService.darkMode" style="cursor: pointer;" matTooltip="Set light mode"><mat-icon style="vertical-align: middle;">dark_mode</mat-icon></mat-slide-toggle>
  <mat-slide-toggle (click)="setDarkMode(true);" [(ngModel)]="darkModeService.darkMode" *ngIf="!darkModeService.darkMode" style="cursor: pointer;" matTooltip="Set dark mode"><mat-icon style="vertical-align: middle;">wb_sunny</mat-icon></mat-slide-toggle>
  <div class="fill-remaining-space"></div>
  <div class="user-box">
    <mat-label class="lang-label">{{ 'CHANGE_LANG_BTN.LANG' | translate }}</mat-label>
    <mat-form-field appearance="fill" class="lang-form-field">
      <mat-select class="lang-select" [(value)]="currentLang" (selectionChange)="onChangeLanguage($event.value)">
        <mat-option *ngFor="let lang of langList" [value]="lang">
          {{lang | uppercase}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="user-box">
    <span>{{ email }}</span>
  </div>
  <div class="user-box">
    <button mat-icon-button (click)="logout();">
        {{ 'NAVBAR.EXIT' | translate}}
        <mat-icon matListIcon>exit_to_app</mat-icon>
    </button>
  </div>
</mat-toolbar>
